import type { HTMLAttributes } from 'react';

export function Card({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`rounded-2xl border border-surface-border bg-surface-raised p-5 shadow-card ${className}`}
      {...props}
    />
  );
}
